module.exports = __webpack_public_path__ + "static/media/trash-yellow-button.671b4736.svg";